import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Transactions from './pages/Transactions';
import Reports from './pages/Reports';
import { Budgets, Goals, Recurring, Settings } from './pages/OtherPages';

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div style={{ display:'flex', justifyContent:'center', paddingTop:100, color:'#888' }}>Loading…</div>;
  return user ? <Layout>{children}</Layout> : <Navigate to="/login" replace />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" toastOptions={{ duration:3000 }} />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/"            element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/transactions" element={<PrivateRoute><Transactions /></PrivateRoute>} />
          <Route path="/budgets"     element={<PrivateRoute><Budgets /></PrivateRoute>} />
          <Route path="/recurring"   element={<PrivateRoute><Recurring /></PrivateRoute>} />
          <Route path="/goals"       element={<PrivateRoute><Goals /></PrivateRoute>} />
          <Route path="/reports"     element={<PrivateRoute><Reports /></PrivateRoute>} />
          <Route path="/settings"    element={<PrivateRoute><Settings /></PrivateRoute>} />
          <Route path="*"            element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
